import { render, staticRenderFns } from "./UploadVideoArea.vue?vue&type=template&id=0f5d19e2&"
import script from "./UploadVideoArea.vue?vue&type=script&lang=js&"
export * from "./UploadVideoArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports